import * as Types from '../modules/graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserInformationQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetUserInformationQuery = {
  __typename?: 'Query';
  viewer: {
    __typename?: 'User';
    avatar: string;
    rawId: string;
    firstName: string;
    username: string;
  };
};

export type HasActiveSubscriptionQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type HasActiveSubscriptionQuery = {
  __typename?: 'Query';
  viewer: { __typename?: 'User'; hasActiveSubscription: boolean };
};

export type HasSeenOnboardingQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type HasSeenOnboardingQuery = {
  __typename?: 'Query';
  viewer: { __typename?: 'User'; hasSeenOnboarding: boolean };
};

export type GetUserWeeklyGoalQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetUserWeeklyGoalQuery = {
  __typename?: 'Query';
  viewer: {
    __typename?: 'User';
    has_weekly_goal?: boolean | null;
    user_weekly_goal_time?: {
      __typename?: 'WeeklyGoalTime';
      hours?: number | null;
      minutes?: number | null;
    } | null;
    user_stats?: {
      __typename?: 'Stats';
      pretty_today_time: string;
      pretty_total_time: string;
      pretty_total_page: string;
      pretty_weekly_goal_time: string;
      user_weekly_goal_percent: number;
    } | null;
  };
};

export type ValidateEmailMutationVariables = Types.Exact<{
  input: Types.ValidateEmailInput;
}>;

export type ValidateEmailMutation = {
  __typename?: 'Mutation';
  validateEmail?: {
    __typename?: 'ValidateEmailPayload';
    success?: boolean | null;
  } | null;
};

export type CreateTemporalTokenMutationVariables = Types.Exact<{
  input: Types.CreateTemporalTokenInput;
}>;

export type CreateTemporalTokenMutation = {
  __typename?: 'Mutation';
  createTemporalToken?: {
    __typename?: 'CreateTemporalTokenPayload';
    success: boolean;
    token?: string | null;
  } | null;
};

export type SendSuccessTrialEmailMutationVariables = Types.Exact<{
  input: Types.SendSuccessTrialEmailInput;
}>;

export type SendSuccessTrialEmailMutation = {
  __typename?: 'Mutation';
  sendSuccessTrialEmail?: {
    __typename?: 'SendSuccessTrialEmailPayload';
    success?: boolean | null;
  } | null;
};

export const GetUserInformationDocument = gql`
  query getUserInformation {
    viewer {
      rawId: raw_id
      firstName: first_name
      username: user_name
      avatar
    }
  }
`;

/**
 * __useGetUserInformationQuery__
 *
 * To run a query within a React component, call `useGetUserInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInformationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserInformationQuery,
    GetUserInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserInformationQuery,
    GetUserInformationQueryVariables
  >(GetUserInformationDocument, options);
}
export function useGetUserInformationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserInformationQuery,
    GetUserInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserInformationQuery,
    GetUserInformationQueryVariables
  >(GetUserInformationDocument, options);
}
export type GetUserInformationQueryHookResult = ReturnType<
  typeof useGetUserInformationQuery
>;
export type GetUserInformationLazyQueryHookResult = ReturnType<
  typeof useGetUserInformationLazyQuery
>;
export type GetUserInformationQueryResult = Apollo.QueryResult<
  GetUserInformationQuery,
  GetUserInformationQueryVariables
>;
export const HasActiveSubscriptionDocument = gql`
  query hasActiveSubscription {
    viewer {
      hasActiveSubscription: has_active_subscription
    }
  }
`;

/**
 * __useHasActiveSubscriptionQuery__
 *
 * To run a query within a React component, call `useHasActiveSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasActiveSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasActiveSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasActiveSubscriptionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HasActiveSubscriptionQuery,
    HasActiveSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HasActiveSubscriptionQuery,
    HasActiveSubscriptionQueryVariables
  >(HasActiveSubscriptionDocument, options);
}
export function useHasActiveSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HasActiveSubscriptionQuery,
    HasActiveSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HasActiveSubscriptionQuery,
    HasActiveSubscriptionQueryVariables
  >(HasActiveSubscriptionDocument, options);
}
export type HasActiveSubscriptionQueryHookResult = ReturnType<
  typeof useHasActiveSubscriptionQuery
>;
export type HasActiveSubscriptionLazyQueryHookResult = ReturnType<
  typeof useHasActiveSubscriptionLazyQuery
>;
export type HasActiveSubscriptionQueryResult = Apollo.QueryResult<
  HasActiveSubscriptionQuery,
  HasActiveSubscriptionQueryVariables
>;
export const HasSeenOnboardingDocument = gql`
  query hasSeenOnboarding {
    viewer {
      hasSeenOnboarding: has_seen_onboarding
    }
  }
`;

/**
 * __useHasSeenOnboardingQuery__
 *
 * To run a query within a React component, call `useHasSeenOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasSeenOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasSeenOnboardingQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasSeenOnboardingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HasSeenOnboardingQuery,
    HasSeenOnboardingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HasSeenOnboardingQuery,
    HasSeenOnboardingQueryVariables
  >(HasSeenOnboardingDocument, options);
}
export function useHasSeenOnboardingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HasSeenOnboardingQuery,
    HasSeenOnboardingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HasSeenOnboardingQuery,
    HasSeenOnboardingQueryVariables
  >(HasSeenOnboardingDocument, options);
}
export type HasSeenOnboardingQueryHookResult = ReturnType<
  typeof useHasSeenOnboardingQuery
>;
export type HasSeenOnboardingLazyQueryHookResult = ReturnType<
  typeof useHasSeenOnboardingLazyQuery
>;
export type HasSeenOnboardingQueryResult = Apollo.QueryResult<
  HasSeenOnboardingQuery,
  HasSeenOnboardingQueryVariables
>;
export const GetUserWeeklyGoalDocument = gql`
  query getUserWeeklyGoal {
    viewer {
      has_weekly_goal
      user_weekly_goal_time {
        hours
        minutes
      }
      user_stats {
        pretty_today_time
        pretty_total_time
        pretty_total_page
        pretty_weekly_goal_time
        user_weekly_goal_percent
      }
    }
  }
`;

/**
 * __useGetUserWeeklyGoalQuery__
 *
 * To run a query within a React component, call `useGetUserWeeklyGoalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWeeklyGoalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWeeklyGoalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWeeklyGoalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserWeeklyGoalQuery,
    GetUserWeeklyGoalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserWeeklyGoalQuery,
    GetUserWeeklyGoalQueryVariables
  >(GetUserWeeklyGoalDocument, options);
}
export function useGetUserWeeklyGoalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserWeeklyGoalQuery,
    GetUserWeeklyGoalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserWeeklyGoalQuery,
    GetUserWeeklyGoalQueryVariables
  >(GetUserWeeklyGoalDocument, options);
}
export type GetUserWeeklyGoalQueryHookResult = ReturnType<
  typeof useGetUserWeeklyGoalQuery
>;
export type GetUserWeeklyGoalLazyQueryHookResult = ReturnType<
  typeof useGetUserWeeklyGoalLazyQuery
>;
export type GetUserWeeklyGoalQueryResult = Apollo.QueryResult<
  GetUserWeeklyGoalQuery,
  GetUserWeeklyGoalQueryVariables
>;
export const ValidateEmailDocument = gql`
  mutation validateEmail($input: ValidateEmailInput!) {
    validateEmail(input: $input) {
      success
    }
  }
`;
export type ValidateEmailMutationFn = Apollo.MutationFunction<
  ValidateEmailMutation,
  ValidateEmailMutationVariables
>;

/**
 * __useValidateEmailMutation__
 *
 * To run a mutation, you first call `useValidateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateEmailMutation, { data, loading, error }] = useValidateEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateEmailMutation,
    ValidateEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateEmailMutation,
    ValidateEmailMutationVariables
  >(ValidateEmailDocument, options);
}
export type ValidateEmailMutationHookResult = ReturnType<
  typeof useValidateEmailMutation
>;
export type ValidateEmailMutationResult =
  Apollo.MutationResult<ValidateEmailMutation>;
export type ValidateEmailMutationOptions = Apollo.BaseMutationOptions<
  ValidateEmailMutation,
  ValidateEmailMutationVariables
>;
export const CreateTemporalTokenDocument = gql`
  mutation createTemporalToken($input: CreateTemporalTokenInput!) {
    createTemporalToken(input: $input) {
      success
      token
    }
  }
`;
export type CreateTemporalTokenMutationFn = Apollo.MutationFunction<
  CreateTemporalTokenMutation,
  CreateTemporalTokenMutationVariables
>;

/**
 * __useCreateTemporalTokenMutation__
 *
 * To run a mutation, you first call `useCreateTemporalTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemporalTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemporalTokenMutation, { data, loading, error }] = useCreateTemporalTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemporalTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTemporalTokenMutation,
    CreateTemporalTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTemporalTokenMutation,
    CreateTemporalTokenMutationVariables
  >(CreateTemporalTokenDocument, options);
}
export type CreateTemporalTokenMutationHookResult = ReturnType<
  typeof useCreateTemporalTokenMutation
>;
export type CreateTemporalTokenMutationResult =
  Apollo.MutationResult<CreateTemporalTokenMutation>;
export type CreateTemporalTokenMutationOptions = Apollo.BaseMutationOptions<
  CreateTemporalTokenMutation,
  CreateTemporalTokenMutationVariables
>;
export const SendSuccessTrialEmailDocument = gql`
  mutation sendSuccessTrialEmail($input: SendSuccessTrialEmailInput!) {
    sendSuccessTrialEmail(input: $input) {
      success
    }
  }
`;
export type SendSuccessTrialEmailMutationFn = Apollo.MutationFunction<
  SendSuccessTrialEmailMutation,
  SendSuccessTrialEmailMutationVariables
>;

/**
 * __useSendSuccessTrialEmailMutation__
 *
 * To run a mutation, you first call `useSendSuccessTrialEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSuccessTrialEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSuccessTrialEmailMutation, { data, loading, error }] = useSendSuccessTrialEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSuccessTrialEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendSuccessTrialEmailMutation,
    SendSuccessTrialEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendSuccessTrialEmailMutation,
    SendSuccessTrialEmailMutationVariables
  >(SendSuccessTrialEmailDocument, options);
}
export type SendSuccessTrialEmailMutationHookResult = ReturnType<
  typeof useSendSuccessTrialEmailMutation
>;
export type SendSuccessTrialEmailMutationResult =
  Apollo.MutationResult<SendSuccessTrialEmailMutation>;
export type SendSuccessTrialEmailMutationOptions = Apollo.BaseMutationOptions<
  SendSuccessTrialEmailMutation,
  SendSuccessTrialEmailMutationVariables
>;
